import axios from "axios";
import { DASH_API } from "../../shared/url.consts";
import { AppInsightsErrorType } from "../../shared/insights/app-insights.consts";
import { sendAppInsightsServerError } from "../../shared/insights/app-insights.utils";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  TermsAndConditionsRequest,
  TermsAndConditionsSummary,
} from "../../types/compliance-terms-and-conditions";

export const getComplianceSummary = async (wisrCustomerId: string) => {
  return axios.get<TermsAndConditionsSummary>(
    `${DASH_API}/compliance/terms-and-conditions/compliance-summary/${wisrCustomerId}`
  );
};

export const getComplianceSummaryResponse = async (wisrCustomerId: string) => {
  try {
    const response = await getComplianceSummary(wisrCustomerId);
    if (response.status === 200 || response.status === 202) {
      return response.data;
    } else {
      sendAppInsightsServerError(
        `Unexpected response received: ${response}`,
        AppInsightsErrorType.GET_COMPLIANCE_TERMS_AND_CONDITIONS
      );
      return response.data;
    }
  } catch (err) {
    sendAppInsightsServerError(
      `error getting compliance summary: ${err}`,
      AppInsightsErrorType.GET_COMPLIANCE_TERMS_AND_CONDITIONS
    );
    throw err;
  }
};

export const fetchGetComplianceSummary = createAsyncThunk(
  "terms-and-conditions/get",
  getComplianceSummaryResponse
);

export const createComplianceSummary = async (
  request: TermsAndConditionsRequest
) => {
  return axios.post<TermsAndConditionsSummary>(
    `${DASH_API}/compliance/terms-and-conditions/create`,
    request
  );
};

export const createComplianceSummaryResponse = async (
  request: TermsAndConditionsRequest
) => {
  try {
    const response = await createComplianceSummary(request);
    if (response.status === 200 || response.status === 202) {
      return response.data;
    } else {
      sendAppInsightsServerError(
        `Unexpected response received: ${response}`,
        AppInsightsErrorType.CREATE_COMPLIANCE_TERMS_AND_CONDITIONS
      );
      return response.data;
    }
  } catch (err) {
    sendAppInsightsServerError(
      `error creating compliance record: ${err}`,
      AppInsightsErrorType.CREATE_COMPLIANCE_TERMS_AND_CONDITIONS
    );
    throw err;
  }
};

export const fetchCreateComplianceSummary = createAsyncThunk(
  "terms-and-conditions/create",
  createComplianceSummaryResponse
);

export const updateComplianceSummary = async (
  request: TermsAndConditionsRequest
) => {
  return axios.put<TermsAndConditionsSummary>(
    `${DASH_API}/compliance/terms-and-conditions/update`,
    request
  );
};

export const updateComplianceSummaryResponse = async (
  request: TermsAndConditionsRequest
) => {
  try {
    const response = await updateComplianceSummary(request);
    if (response.status === 200 || response.status === 202) {
      return response.data;
    } else {
      sendAppInsightsServerError(
        `Unexpected response received: ${response}`,
        AppInsightsErrorType.UPDATE_COMPLIANCE_TERMS_AND_CONDITIONS
      );
      return response.data;
    }
  } catch (err) {
    sendAppInsightsServerError(
      `error updating compliance record: ${err}`,
      AppInsightsErrorType.UPDATE_COMPLIANCE_TERMS_AND_CONDITIONS
    );
    throw err;
  }
};

export const fetchUpdateComplianceSummary = createAsyncThunk(
  "terms-and-conditions/update",
  updateComplianceSummaryResponse
);
